var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data && _vm.data.length > 0)?_c('div',{staticClass:"table-wrapper"},[_c('table',_vm._l((_vm.data),function(row,iRow){return _c('tr',{key:iRow},_vm._l((row),function(entry,iEntry){return _c('td',{key:iEntry,class:{ bold: entry.bold }},[_vm._v(_vm._s(entry.value))])}),0)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }